import { useState } from 'react'
import type { MessagingWindow } from '@/lib/api/deep-dive.types'
import { MessagingDeliverySection } from '@/components/systems/MessagingDeliverySection'
import { SegmentedPicker } from '@/components/systems/SegmentedPicker'

/**
 * Twilio's service screen — SMS delivery.
 *
 * One channel, from `twilio/messaging/*`: sent, failure rate, deliverability and
 * delivered, the hourly chart, the recent delivery failures and the blockage
 * banner.
 *
 * There is no channel switch. The screen used to carry one, because both
 * channels came from these routes with a `channel` parameter and SendGrid's
 * email figures were shown here under Twilio's name. Each vendor now has its own
 * route family — `sendgrid/messaging/*` for email, and this one for SMS — and
 * asking this family for email is a 400. Email lives on the SendGrid screen.
 *
 * There is no outage header either: these routes report delivery, not uptime,
 * and `twilio/overview` does not exist. A "down for HH:MM:SS" counter would have
 * had nothing behind it.
 */
export function TwilioServiceManagement() {
  const [window, setWindow] = useState<MessagingWindow>('24h')

  return (
    <div className="space-y-6 pb-4">
      <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3">
        <div className="min-w-0">
          <h1 className="text-fg text-3xl leading-tight font-semibold tracking-tight sm:text-[32px]">
            Twilio Service Management
          </h1>
          <p className="text-fg-muted mt-1 text-sm">
            Battery-calculator SMS delivery, from Twilio's own logs.
          </p>
        </div>
        <SegmentedPicker value={window} onChange={setWindow} label="Window" />
      </div>

      <MessagingDeliverySection provider="twilio" window={window} />
    </div>
  )
}
